<svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.48704 7.15211C6.23165 7.15211 5.21396 8.16981 5.21396 9.4252V26.4737C5.21396 27.7291 6.23165 28.7468 7.48704 28.7468H30.2174C31.4727 28.7468 32.4904 27.7291 32.4904 26.4737V15.6785H5.2145V12.8371H32.4904V9.4252C32.4904 8.16981 31.4727 7.15211 30.2174 7.15211H7.48704ZM16.0113 23.0652H8.62389V25.9067H16.0113V23.0652ZM17.7146 23.0652H20.5559V25.9067H17.7146V23.0652Z"
    fill="#150E0B"
  />
</svg>
